import { TitlePropsType } from "./types";
import "./title.scss";

const Title = ({ title, color }: TitlePropsType) => {
  const classes = ["title", color].join(" ");
  return <h2 className={classes}>{title}</h2>;
};

export default Title;
